/**
 * 页面路径到中文名称的映射
 * 格式：我的收入-[模块]-[页面]
 */
export const PAGE_NAME_MAP: Record<string, string> = {
  '/': '我的收入-加载页',
  '/Main': '我的收入-首页-全部收入',
  '/Main/allIncome': '我的收入-首页-全部收入',
  '/Main/detailIncome/salePerformance': '我的收入-绩效工资详情-销量绩效',
  '/Main/detailIncome/excutePerformance': '我的收入-绩效工资详情-执行绩效',
  '/Main/detailIncome/domBonus': '我的收入-绩效工资详情-附加奖金',
  '/Main/myMonthSalePerformanceIncome': '我的收入-绩效指标分页-月度销量绩效',
  '/Main/myQuarterSalePerformanceIncome': '我的收入-绩效指标分页-季度销量绩效',
  '/Main/myHalfYearSalePerformanceIncome': '我的收入-绩效指标分页-半年度销量绩效',
  '/Main/specialInspire': '我的收入-项目激励-激励列表',
  '/monthExcutePerformanceTarget': '我的收入-执行绩效-指标详情',
  '/MyProductIncome': '我的收入-产品收入-收入列表',
  '/MyReply': '我的收入-我的回复-回复列表',
  '/MyReply/MyReplySubmit': '我的收入-我的回复-提交回复',
  '/ProjectInspireTargetDetail': '我的收入-项目激励-激励项目详情',
};

/**
 * 根据路径获取页面名称
 * @param pathname 页面路径
 * @returns 页面中文名称
 */
export const getPageName = (pathname: string): string => {
  // 先尝试精确匹配
  if (PAGE_NAME_MAP[pathname]) {
    return PAGE_NAME_MAP[pathname];
  }
  
  // 尝试前缀匹配（处理动态路由如 /MyReply/id/:id）
  for (const [path, name] of Object.entries(PAGE_NAME_MAP)) {
    if (pathname.startsWith(path + '/')) {
      return name;
    }
  }
  
  return '我的收入-未知页面';
};
